import { writable } from "svelte/store";

export let popupStore = writable(false);